import { HttpErrorResponse } from '@angular/common/http';

import { ProblemDetailsV1 } from '@core/models/diagnostics';

/**
 * The problem+json body, or nothing when the response carried none (a gateway page, a network failure). An error the
 * gateway raises itself carries `{ statusCode, message }` instead, so its message stands in for the detail.
 */
export function problemDetails(error: HttpErrorResponse): ProblemDetailsV1 {
  const body: unknown = error.error;
  if (typeof body !== 'object' || body === null) {
    return {};
  }
  const { title, detail, message } = body as Record<string, unknown>;
  const text = [detail, message].find((value): value is string => typeof value === 'string' && value.trim().length > 0);
  return {
    title: typeof title === 'string' && title.length > 0 ? title : undefined,
    detail: text?.trim()
  };
}

/** Whether the gateway answered in its own `{ statusCode, message }` shape, before the request reached a backend. */
export function isGatewayError(error: HttpErrorResponse): boolean {
  const body: unknown = error.error;
  return (
    typeof body === 'object' && body !== null && typeof (body as Record<string, unknown>)['statusCode'] === 'number'
  );
}

/** The wait a 429's `Retry-After` names in seconds, or null when the header is absent or the browser cannot read it. */
export function retryAfterSeconds(error: HttpErrorResponse): number | null {
  const value = error.headers.get('Retry-After')?.trim();
  return value && /^\d+$/.test(value) ? Number(value) : null;
}
